module.exports = __webpack_public_path__ + "static/img/fwzl@2x.98f3b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/fwzl@2x.png
// module id = m5Rf
// module chunks = 1